<template>
  <div
    ref="slider"
    class="vue-nouislider"
  />
</template>

<script setup>
// Adapted from https://github.com/Sitronik/vue3-nouislider
import noUiSlider from '@js/plugins/nouislider';

const props = defineProps({
	config: {
		type: Object,
		required: true
	},
	round: {
		type: Boolean,
		default: true
	},
	modelValue: {
		type: [Array, Number],
		required: true
	}
});

const emit = defineEmits([
	'update:modelValue',
	'start',
	'slide',
	'drag',
	'update',
	'change',
	'set',
	'end'
]);
// Element reference
const slider = ref(null);


onMounted(() => {
	initSlider();

	watch(() => props.modelValue, (newValue) => {
		slider.value.noUiSlider.set(newValue);
	});

	watch(() => props.config, () => {
		destroySlider();
		initSlider();
	});
});

const destroySlider = () => {
	slider.value.noUiSlider.destroy();
};

const initSlider = () => {
	// Create noUiSlider
	noUiSlider.create(slider.value, { ...props.config, start: props.modelValue });
	// Bind all events
	['start', 'slide', 'drag', 'update', 'change', 'set', 'end'].forEach((eventName) => {
		slider.value.noUiSlider.on(eventName, (data) => {
			if (props.round) {
				data = data.map(Math.round);
			}
			if (eventName === 'change') {
				emit('update:modelValue', data);
			}
			emit(eventName, data);
		});
	});
};

</script>
<style lang="scss" src="@/src/sass/nouislider/nouislider.scss"></style>
